import { Sparkles, Wind, Palette, Shield, Droplets, Settings, Waves, Lightbulb } from 'lucide-react';

// Tier-based main services - Interior & Exterior
export const tierServices = [
  {
    category: 'Interior Detail',
    key: 'interior',
    icon: Sparkles,
    description: 'Complete interior care for every surface.',
    tiers: [
      {
        name: 'Moderate',
        tier: 'moderate',
        description: 'Quick refresh — vacuum, wipe down, windows, and basic interior clean.'
      },
      {
        name: 'Mad',
        tier: 'mad',
        description: 'Full restoration — steam clean, shampoo carpets and seats, deep stain extraction, and premium leather treatment.',
        featured: true
      }
    ]
  },
  {
    category: 'Exterior Detail',
    key: 'exterior',
    icon: Droplets,
    description: 'Premium exterior treatment for a flawless finish.',
    tiers: [
      {
        name: 'Moderate',
        tier: 'moderate',
        description: 'Hand wash, wheels, tires, and dry. Tire shine. A clean, fresh exterior.'
      },
      {
        name: 'Mad',
        tier: 'mad',
        description: 'Hand wash, iron decontamination, clay bar, door jambs, windows, trim restoration & sealant, tire shine, and 3-month sealant.',
        featured: true
      }
    ]
  }
];

// Dynamic pricing matrix by vehicle type
export const pricingMatrix = {
  interior: {
    'Sedan':        { moderate: '$125 – $175', mad: '$225 – $275' },
    'SUV (2 Row)':  { moderate: '$150 – $200', mad: '$250 – $300' },
    'SUV (3 Row)':  { moderate: '$175 – $225', mad: '$275 – $325' },
    'Coupe':        { moderate: '$110 – $160', mad: '$210 – $260' },
    'Truck':        { moderate: '$175 – $225', mad: '$275 – $325' },
    'Van':          { moderate: '$125 – $200', mad: '$225 – $300' },
    'RV':           { moderate: '$1,500+ Starting', mad: '$1,500+ Starting', note: 'More information required for an accurate quote.' },
    'Motorcycle':   null,
    'Other':        null
  },
  exterior: {
    'Sedan':        { moderate: '$125', mad: '$225' },
    'SUV (2 Row)':  { moderate: '$150', mad: '$250' },
    'SUV (3 Row)':  { moderate: '$150', mad: '$250' },
    'Coupe':        { moderate: '$110', mad: '$210' },
    'Truck':        { moderate: '$175', mad: '$275' },
    'Van':          { moderate: '$150', mad: '$250' },
    'RV':           { moderate: '$200 – $400', mad: '$500 – $700' },
    'Motorcycle':   { moderate: '$100', mad: '$100', note: 'Single-tier service for motorcycles.' },
    'Other':        null
  }
};

// All add-on services
export const addOnServices = [
  {
    name: 'Paint Correction',
    icon: Palette,
    description: 'Multi-stage polish to remove swirls, scratches, and oxidation. Restores paint to showroom quality.'
  },
  {
    name: 'Clay Bar + Polishing',
    icon: Sparkles,
    description: 'Thorough decontamination and polishing for a mirror-like finish that enhances color depth.'
  },
  {
    name: 'Ceramic Coating',
    icon: Shield,
    description: 'Long-lasting hydrophobic protection and brilliant gloss. Advanced ceramic coating for ultimate paint defense.'
  },
  {
    name: 'Odor Removal',
    icon: Wind,
    description: 'Professional-grade treatment that neutralizes and removes unwanted odors at the source.'
  },
  {
    name: 'Undercarriage Cleaning',
    icon: Waves,
    description: 'High-pressure rinse of the underside to remove road salt, grime, and buildup.'
  },
  {
    name: 'Headlight Restoration',
    icon: Lightbulb,
    description: 'Restore cloudy, yellowed headlights to crystal clear for better visibility and a fresh look.'
  },
  {
    name: 'Interior Finishes (Gloss & Matte)',
    icon: Sparkles,
    description: 'Specialized treatments for interior trim with proper gloss or matte finish restoration.'
  },
  {
    name: 'Interior Scent',
    icon: Wind,
    description: 'Premium fragrance application to leave your cabin smelling fresh and inviting.'
  },
  {
    name: 'Spray-On Wax',
    icon: Droplets,
    description: 'Quick application for added shine and a light protective layer.'
  },
  {
    name: 'Engine Bay Detailing',
    icon: Settings,
    description: 'Safe cleaning and dressing of your engine compartment for a clean, well-maintained look.'
  },
  {
    name: 'Carpet, Seat & Ceiling Extraction',
    icon: Droplets,
    description: 'Deep hot-water extraction to lift embedded dirt, stains, and allergens from fabric surfaces.'
  }
];

export const portfolioImages = [
  'https://customer-assets.emergentagent.com/job_detailing-landing-1/artifacts/n2rr2fsa_IMG_9106.jpeg',
  'https://customer-assets.emergentagent.com/job_detailing-landing-1/artifacts/0mdfa4xi_IMG_5907.jpeg',
  'https://customer-assets.emergentagent.com/job_detailing-landing-1/artifacts/iat7dabb_IMG_5921.jpeg',
  'https://customer-assets.emergentagent.com/job_detailing-landing-1/artifacts/qa45hssb_IMG_5934.jpeg'
];

export const whyChooseUs = [
  {
    title: 'Fully Mobile',
    icon: Droplets,
    description: 'Our vehicles carry their own water and power — we detail anywhere, anytime.'
  },
  {
    title: 'Your Schedule',
    icon: Sparkles,
    description: 'We come to your home, office, or parking lot at a time that works for you.'
  },
  {
    title: 'Mad Max Quality',
    icon: Waves,
    description: 'Premium products and meticulous attention to every detail, every time.'
  },
  {
    title: 'Showroom Results',
    icon: Shield,
    description: 'We deliver a flawless finish that turns heads — every time, no exceptions.'
  }
];

// Legacy exports
export const services = tierServices;
export const additionalServices = addOnServices;
